import { useQuery } from '@tanstack/react-query';
import type {
  CustomerResponseDto,
  CustomerSortBy,
  ListParams,
} from '@relay-towing/api';
import { useHybridAuth } from '../../hooks/useHybridAuth';
import { useDriverStateV2 } from '../../hooks/useDriverStateV2';
import { getList } from '../list';

export const useGetCustomers = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const { driver } = useDriverStateV2();

  return useQuery({
    queryKey: ['customers', driver?.companyId],
    queryFn: async () => {
      if (!driver?.companyId) {
        throw new Error('Company ID not available');
      }

      const token = await getAccessTokenSilently();
      // Every account on one page: the call forms offer them all in a single
      // picker, so there is nothing to page through.
      const params = {
        pageNo: 1,
        pageSize: 1000,
      } satisfies ListParams<CustomerSortBy>;

      return getList<CustomerResponseDto>('/customers', params, {
        token,
        companyId: driver.companyId,
      });
    },
    enabled: !!driver?.companyId,
  });
};
